import {auth} from './auth';
import {news} from './content/news';
import {qna} from './content/qna';
import {home} from './content/home';
import {summaries} from './content/summaries';
import {predictions} from './content/predictions';
import {analysis} from './content/analysis';
import {topics} from './content/topics';
import {ehr} from './content/ehr';
import {chats} from './content/chats';
import {share} from './content/share';

export const services = {
  auth,
  news,
  home,
  ehr,
  qna,
  summaries,
  predictions,
  analysis,
  topics,
  chats,
  share,
};
